import { IWorkGroup } from "../interfaces/IWorkGroup";
import { thanos26GetJson } from "./thanos26Client";

async function getAllWorkgroups(): Promise<IWorkGroup[]> {
    return thanos26GetJson("manager/WorkGroups");
}

export default { getAllWorkgroups };
